if (!customElements.get('hover-animation')) {
  customElements.define(
    'hover-animation',
    class HoverAnimation extends HTMLElement {
      connectedCallback() {
        this.wrapper = this;
        this.init();
      }

      init() {
        const hoverItems = this.wrapper.querySelectorAll('.hover-animation-item');

        // Add hovered class to first element by default
        if (hoverItems.length > 0) {
          hoverItems[0].classList.add('is-active');
        }

        hoverItems.forEach(item => {
          item.addEventListener('mouseenter', () => {
            // Remove hovered from all items
            hoverItems.forEach(i => i.classList.remove('is-active'));

            // Add hovered to current item
            item.classList.add('is-active');
          });

        });
      }
    }
  );
}
